import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { Snackbar, SnackbarContent, Button, Stack, Slide, Box, Typography, SlideProps } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PreferencesDialog from './PreferencesDialog';

const COOKIE_KEY = 'simsola.ai_site_consent_v1';
const TransitionUp = (props: SlideProps) => <Slide {...props} direction="up" />;

const CookieModal: React.FC = () => {
	const [open, setOpen] = useState(false);
	const [prefsOpen, setPrefsOpen] = useState(false);
	const navigate = useNavigate();

	const shouldShowBanner = () => !Cookies.get(COOKIE_KEY);

	useEffect(() => {
		if (shouldShowBanner()) {
			setTimeout(() => setOpen(true), 4000);
		}
	}, []);

	const save = (payload: object) => {
		Cookies.set(COOKIE_KEY, JSON.stringify(payload), {
			expires: 180,
			sameSite: 'lax',
			secure: true,
			path: '/'
		});
		setOpen(false);
	};

	const handlePolicyClick = () => {
		setOpen(false);
		navigate('/privacy-policy');
		if (shouldShowBanner()) {
			setTimeout(() => setOpen(true), 4000);
		}
	};

	const handlePrefsClose = () => {
		setPrefsOpen(false);
		if (shouldShowBanner()) {
			setTimeout(() => setOpen(true), 4000);
		}
	};

	return (
		<>
			<Snackbar
				open={open}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
				TransitionComponent={TransitionUp}>
				<SnackbarContent
					sx={{
						p: 2,
						maxWidth: 500,
						borderRadius: 10
					}}
					message={
						<Box display="flex" flexDirection="column" gap={2}>
							<Typography
								variant="body2"
								sx={{
									fontFamily: 'DM Sans',
									fontSize: 16,
									lineHeight: '150%'
								}}>
								By clicking “Accept all cookies”, you agree Simsola can store cookies on your device and disclose
								information in accordance with our{' '}
								<u style={{ cursor: 'pointer' }} onClick={handlePolicyClick}>
									Cookie Policy
								</u>
								.
							</Typography>

							<Stack direction="row" spacing={1}>
								<Button
									variant="contained"
									onClick={() => save({ necessary: true, preferences: true, statistics: true, marketing: true })}
									sx={{
										fontFamily: 'DM Sans',
										borderRadius: '10px',
										fontWeight: 500,
										fontSize: 16,
										width: '50%',
										textTransform: 'capitalize'
									}}>
									Accept All Cookies
								</Button>

								<Button
									variant="outlined"
									onClick={() => save({ necessary: true, preferences: false, statistics: false, marketing: false })}
									sx={{
										fontFamily: 'DM Sans',
										borderRadius: '10px',
										width: '50%',
										fontWeight: 500,
										fontSize: 16,
										textTransform: 'capitalize',
										backgroundColor: 'rgba(108, 108, 108, 1)',
										color: 'white'
									}}>
									Accept only Necessary
								</Button>
							</Stack>

							<Button
								variant="contained"
								fullWidth
								onClick={() => {
									setPrefsOpen(true);
									setOpen(false);
								}}
								sx={{
									fontFamily: 'DM Sans',
									borderRadius: '10px',
									fontWeight: 500,
									fontSize: 16,
									textTransform: 'capitalize'
								}}>
								Preferences
							</Button>
						</Box>
					}
				/>
			</Snackbar>

			<PreferencesDialog open={prefsOpen} onClose={handlePrefsClose} />
		</>
	);
};

export default CookieModal;
